export const environment = {
  production: true,
  feature_resource_managment: true,
};
